import "../servise.scss"
import ServiseFooter from "./servise_footer";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";

const ServiseTechnical = () => {
   return (
    <div className="servise-page">
      <>
          <Helmet>
              <title>Pro Moto - przeglądy techniczne</title>
              <meta
              name="description"
              content="Regularny przegląd to najlepszy sposób, 
              by sezon zacząć bez niespodzianek i zakończyć go w jednym kawałku. 
              W PRO MOTO wykonujemy kompleksową kontrolę stanu technicznego
               Twojego motocykla, skutera lub quada – szybko, rzetelnie i bez zbędnych kosztów."
              />
              <link rel="canonical" href="https://promotoserwis.pl/przeglady-techniczne" />
          </Helmet>
      </>
      <section className="servise-hero">
        <div className="servise-hero__content">
          <motion.h1
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}>PRZEGLĄDY TECHNICZNE</motion.h1>
          <motion.h2
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>
              Regularny przegląd to najlepszy sposób, by sezon zacząć <strong>bez niespodzianek</strong> i 
              zakończyć go w jednym kawałku. W <strong>PRO MOTO</strong> wykonujemy kompleksową 
              kontrolę stanu technicznego Twojego motocykla, skutera lub quada – szybko, 
              rzetelnie i bez zbędnych kosztów.
          </motion.h2>


          <button
            className="servise-scroll-btn"
            onClick={() =>
              document.querySelector(".servise-extra").scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            <span className="arrow"></span>
          </button>
        </div>
      </section>

      <section className="servise-extra">
        <div className="servise-extra__container">

          <div className="servise-block">
            <h3 className="servise-block_title">Co sprawdzamy?</h3>
          </div>

          <div className="servise-block">
            <h2>Koła & ogumienie</h2>
            <ul>
              <li>Ciśnienie i bieżnik opon</li>
              <li>Stan łożysk kół i osi</li>
            </ul>
          </div>

          <div className="servise-block">
            <h2>Hamulce</h2>
            <ul>
              <li>Grubość klocków i tarcz</li>
              <li>Płyn hamulcowy, szczelność przewodów</li>
              <li>Mocowanie zacisków przednich i tylnych</li>
            </ul>
          </div>

          <div className="servise-block">
            <h2>Zawieszenie & układ kierowniczy</h2>
            <ul>
              <li>Praca lag, uszczelniacze, amortyzatory</li>
              <li>Łożyska główki ramy, drążki i wahacze (ATV)</li>
            </ul>
          </div>

          <div className="servise-block">
            <h2>Napęd</h2>
            <ul>
              <li>Naciąg i smarowanie łańcucha / stan paska CVT</li>
              <li>Olej w wale napędowym lub Kardanie</li>
            </ul>
          </div>

          <div className="servise-block">
            <h2>Silnik & płyny eksploatacyjne</h2>
            <ul>
              <li>Poziom oleju, płynu chłodniczego</li>
              <li>Filtr powietrza, szczelność przewodów paliwowych</li>
              <li>Rozruch i kultura pracy jednostk</li>
            </ul>
          </div>
          <div className="servise-block">
            <h2>Instalacja świetlna & bezpieczeństwo</h2>
            <ul>
              <li>Sprawność świateł, kierunkowskazów i klaksonu</li>
              <li>Napięcie ładowania akumulatora (bez napraw elektroniki)</li>
            </ul>
          </div>
          <div className="servise-block">
            <h2>Kiedy warto zrobić przegląd?</h2>
            <ul>
              <li><strong>Przed startem sezonu</strong> – żeby po zimie nic Cię nie zaskoczyło.</li>
              <li><strong>Przed długą wyprawą</strong> – lepiej znaleźć usterkę w warsztacie niż na autostradzie.</li>
              <li><strong>Po zakupie używanego sprzętu</strong> – zyskasz pewność, że wszystko jest pod kontrolą.</li>
            </ul>
          </div>

          <ServiseFooter/>

        </div>
      </section>
    </div>
  );
};


export default ServiseTechnical;